import {Outlet} from 'react-router'
import {useHasRequiredRecords} from '~/hooks'
import {Placeholder, Layout} from '~/components'

export const RecordsRoute = ({awaitRecords, placeholderProps}) =>
	useHasRequiredRecords(awaitRecords) ? <Outlet /> : <Loader {...placeholderProps} />

const Loader = props => {
	return (
		<Layout style={{height: '100vh', width: '100%'}} horizontal="center" vertical="center">
			<Placeholder name="loading" animation="hourglass" {...props} />
		</Layout>
	)
}
